import React, { Suspense, lazy } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "../assets/styles/App.scss";
import ErrorBoundary from '../components/ErrorBoundary';
import Movies from "../containers/Movies";
//import Series from "../containers/Series";
import Layout from "../components/Layout";
import Loader from "../components/Loader";
import PageNotFound from "../containers/PageNotFound";

const Series = lazy(() => import("../containers/Series"));

const App = () => (
  <BrowserRouter>
    <Layout>
      <ErrorBoundary>
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <Switch>
          <Route exact path="/" component={Movies} />
          <Route path="/series" component={Series} />
          <Route component={PageNotFound} />
        </Switch>
      </Suspense>
      </ErrorBoundary>
    </Layout>
  </BrowserRouter>
);
export default App;
